import api from '../lib/api'
import router from '../router/index'

export default {
    actions: {
        sendRequest({commit}, payload) {
            commit('clearError');

            const data = payload.data;

            if (typeof data === 'object') {
                for (let key in data) {
                    if (data[key] === '') {
                        data[key] = null;
                    }
                }
            }

            const requestOptions = {
                method: payload.method,
                url: payload.path,
                data,
            };

            if (payload.headers) requestOptions.headers = payload.headers;

            if (payload.params) requestOptions.params = payload.params;

            return api.request(requestOptions)
                .then((res) => {

                    let data = res.data;

                    return data
                })
                .catch(err => {

                    if (err.response && err.response.data && err.response.status === 400) {

                        if (err.response.data.error === "token is empty") {
                            commit('setLogin', 'false');
                            router.push('/login');
                            throw err;
                        }

                        if (err.response.data.valid_errors && payload.formErrors.add !== undefined) {

                            payload.formErrors.clear();

                            err.response.data.valid_errors.forEach(item => {
                                payload.formErrors.add({
                                    field: item.field,
                                    msg: item.message,
                                });
                            });
                        }

                        if (err.response.data.error) {
                            commit('setError', err.response.data.error)
                        }

                    } else if (err.response && err.response.data && err.response.status === 403) {

                        if (err.response.data.error === "forbidden") {
                            commit('setLogin', 'false');
                            router.push('/login');
                            throw err;
                        }

                    } else {
                        commit('setError', err.message)
                    }

                    throw err
                })
        }
    }
}